import { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import eye from '../../assets/images/eye.svg';
import paper from '../../assets/images/paper.svg';
import { IDexTrade } from '@kattana-io/common';
import './styles.scss';
import { connect } from 'react-redux';
import { actionShowModal } from '../../actions/modal';
import { ModalTypes } from '../../reducers/modal';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';

interface IStatsProps {
  data: any; // we don't have correct type for this
  quote_decimals: number
  quote: string | undefined;
  address: string | undefined;
  chain: string;
  actionShowModal: (type: ModalTypes, props: any) => void;
}

const Stats = (props: IStatsProps) => {
  const openModal = () => props.actionShowModal(
    ModalTypes.wallet,
    {
      wallet: props.data.wallet,
      address: props.address,
      chain: props.chain,
      timeframe: 'week',
    });

  useEffect(() => {
    setTimeout(ReactTooltip.rebuild, 0);
  }, []);

  const sumArr = (array: any[]) => {
    const res = array.reduce((acc: any, item: any) => {
      acc.sum += Number(item.amountOut) / 10 ** props.quote_decimals;
      return acc;
    }, {sum : 0});
    return res.sum;
  };

  const tradesFiltered = props.data?.tradesWithThisWallet?.reduce((acc: {buy: IDexTrade[], sell: IDexTrade[]}, item: IDexTrade) => {
    item.buy === 1 ? acc.buy.push(item) : acc.sell.push(item);
    return acc;
  }, { buy: [], sell: [] }) || {buy: [], sell: []};

  const buy = tradesFiltered.buy;
  const buyQuote = sumArr(tradesFiltered.buy);
  const sell = tradesFiltered.sell;
  const sellQuote = sumArr(tradesFiltered.sell);

  const html = `<div class="data__container">
    <div class="text--bald totalTx">
      <span class="data__title">Total tx:</span>
      <span>${buy.length + sell.length}</span>
    </div>
    <div class="text--bald space__between">
      <span class="data__title">Buys: </span>
      <span><span class="text--green">${buy.length}</span> / <span class="text--green">${buyQuote.toFixed(5)} ${props.quote}</span></span>
    </div>
    <div class="text--bald space__between">
      <span class="data__title">Sells: </span>
      
      <span><span class="text--red">${sell.length}</span> / <span class="text--red">${sellQuote.toFixed(5)} ${props.quote}</span></span>
    </div> 
    <div class="text--bald profitTx space__between">
      <span class="data__title">Profit: </span>
      <span> ${(sellQuote - buyQuote).toFixed(4)} ${props.quote} </span>
    </div>
  </div>`;

  return (
    <div className="stats_column">
      <Image data-tip="Bot / Smart Contract" src={props.data.bot === 1 ? paper : undefined} size='m' />
      <Text size={10} className={`info info${buy.length > 0 ? '--green' : ''}${sell.length > 0 ? '--red' : ''} text--grey-600 text--weight-500`}
      // data-html={true} data-tip={html}
      >
        {buy.length + sell.length}
      </Text>
      {(buy.length + sell.length) > 1 &&
        (<div className='stats_column__eye' onClick={openModal}>
          <Image data-tip= 'Show more trades with this wallet' src={eye} size='s'/>
        </div>)
      }
    </div>
  );
};

export default connect(null, { actionShowModal })(Stats);
